import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api.ts";
import type { TenantOut } from "@/types/api.ts";

export const tenantKeys = {
  current: ["tenant", "current"] as const,
};

export function useTenant() {
  return useQuery({
    queryKey: tenantKeys.current,
    queryFn: () => api.get<TenantOut>("/tenant"),
    staleTime: 5 * 60_000, // datos de empresa cambian rara vez
  });
}
